var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcontvEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.96,
    height: 28.453,
    viewBox: "0 0 39.96 28.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_162255",
    "data-name": "Groupe 162255",
    transform: "translate(-44.715 -294.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1988_",
    d: "M38.786,73.72H1.173A1.174,1.174,0,0,0,0,74.894V96.5a1.174,1.174,0,0,0,1.174,1.174H15.842v2.148H12.676a1.174,1.174,0,0,0,0,2.347H27.284a1.174,1.174,0,0,0,0-2.347H24.118V97.678H38.786A1.174,1.174,0,0,0,39.96,96.5V74.894A1.174,1.174,0,0,0,38.786,73.72ZM21.771,99.826H18.189V97.678h3.582Zm15.842-4.5H2.347V76.067H37.613Z",
    transform: "translate(44.715 220.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-eye",
    "data-name": "Icon ionic-md-eye",
    d: "M11.716,7.383A10.179,10.179,0,0,0,2.25,13.764a10.212,10.212,0,0,0,18.932,0A10.179,10.179,0,0,0,11.716,7.383Zm0,10.636a4.256,4.256,0,1,1,4.3-4.255A4.291,4.291,0,0,1,11.716,18.019Zm0-6.808A2.553,2.553,0,1,0,14.3,13.764,2.576,2.576,0,0,0,11.716,11.211Z",
    transform: "translate(52.98 292.629)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcontvEye);
export default __webpack_public_path__ + "static/media/icontv-eye.a4dea4246d8b01ae20ec525e8ed485a4.svg";
export { ForwardRef as ReactComponent };